import { render } from "./Yushou.vue?vue&type=template&id=a57c7d3c&scoped=true"
import script from "./Yushou.vue?vue&type=script&lang=js"
export * from "./Yushou.vue?vue&type=script&lang=js"

import "./Yushou.vue?vue&type=style&index=0&id=a57c7d3c&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57c7d3c"]])

export default __exports__